import React from 'react';
import { CTAButton } from './CTAButton';
type TransformCTAProps = {
  headline: string;
  buttonLabel?: string;
  variant?: 'light' | 'dark';
};

/**
 * "Botón transformacional" repeated below every section:
 * a one-line promise of the change + the checkout button.
 */
export function TransformCTA({
  headline,
  buttonLabel = 'QUIERO LA RUTA HIPOTIROIDISMO AHORA',
  variant = 'light'
}: TransformCTAProps) {
  const isDark = variant === 'dark';
  return <div className="mx-auto mt-10 w-full max-w-2xl px-1" data-id="element-258" data-mp="27722abrv69f6">
      <div className={`rounded-3xl border p-5 text-center sm:p-7 ${isDark ? 'border-white/15 bg-white/5' : 'border-navy-100 bg-navy-50/70'}`} data-id="element-259" data-mp="234ffwqdypgpd">
        <p className={`mb-4 font-display text-lg font-bold leading-snug sm:text-2xl ${isDark ? 'text-white' : 'text-navy-900'}`} data-id="element-260" data-mp="2c3am42h0aqso">
          {headline}
        </p>
        <CTAButton label={buttonLabel} pulse={false} data-id="element-261" data-mp="3niftvkvzvfj5" />
        <p className={`mt-3 text-[11px] font-medium sm:text-xs ${isDark ? 'text-navy-100/70' : 'text-navy-700/70'}`} data-id="element-262" data-mp="3qpu1gi9t654h">
          Descarga inmediata · Pago único · Garantía de 7 días
        </p>
      </div>
    </div>;
}